export const ChatLoadingMessageBubble = () => {
    return (
        <div className="chatbot_bubble">
            <div className="chatbot_bubble__img"><img src="https://content.harstatic.com/media/icons/a_all/chat_ai_icon2.svg" /></div>
            <div className="chatbot_bubble__text">
                <div className='d-flex'>
                    <div className='mr-2'>Loading </div>
                    <div><img src='https://content.harstatic.com/media/other/dots-loading.gif' /></div>
                </div>
            </div>
        </div>
    )
}
